import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface MobileListItemProps {
  children: ReactNode;
  to: string;
  className?: string;
}

export function MobileListItem({
  children,
  to,
  className,
}: MobileListItemProps) {
  const isClickable = !!to;
  const Wrapper = isClickable ? Link : "div";

  return (
    <div
      className={cn(
        "bg-white rounded-lg border border-gray-200 p-4 shadow-sm",
        isClickable && [
          "cursor-pointer transition-all duration-200",
          "hover:shadow-md hover:border-gray-300",
          "active:scale-[0.98] active:shadow-sm",
        ],
        className,
      )}
    >
      <Wrapper to={to}>{children}</Wrapper>
    </div>
  );
}
